import { Component, Input, OnInit, HostBinding, EventEmitter, Output, AfterViewInit, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { SolutionService } from '../../service/solution.service';
import { NumberRangeValue, NumberRangeValueConvertor } from '../../entity/conditionvalue/numberrangevaue';
import { BigNumber } from 'bignumber.js';
// import { NumberRangeValue } from '../../entity/conditionvalue/numberrangevaue';


@Component({
    selector: 'app-filter-number',
    templateUrl: './number.component.html',
    styleUrls: ['./number.component.scss']
})

export class NumberComponent implements OnInit, AfterViewInit,OnChanges {

    // @Input() item:any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    @Output('searchHandle') searchHandle = new EventEmitter();

    /**判断是否是在扩展区域展示 */
    extend: boolean = false;
    /**判断是否显示label */
    showlabel: boolean = true;
    canNull: boolean = true;

    number: string;
    beginValue: any;
    endValue: any;
    precision: number;
    placeholder: string;
    beginPlaceHolder: string;
    endPlaceHolder: string;
    bigNumber: boolean;
    max: number;
    min: number;

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }

    _item: any;
    numberRange: string;
    @Input()
    set item(nr: any) {
        this._item = nr;
        this.precision = nr.control.precision;
        this.bigNumber = nr.control.bigNumber;
        this.constructMultiFieldNumberRange(nr.value as NumberRangeValue);
        if (this._item && this._item.control && this._item.control.hasOwnProperty('isExtend')) {
            this.extend = this._item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this._item.control.showLabel;
            }
        }
    }

    get item() {
        return this._item;
    }

    /**
     * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
     */
    @Input() changeFields: Array<string> = [];
    constructor(private solutionService: SolutionService, private readonly element: ElementRef) { }

    ngOnInit(): void {
        if (this.item) {
            const type = Object.prototype.toString.call(this.item.placeHolder);
            if (type == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.placeholder = this.item.control.placeholder;
                }
            }
            else {
                this.placeholder = this.item.placeHolder;
            }
            const beginplac = Object.prototype.toString.call(this.item.beginPlaceHolder);
            if (beginplac == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.beginPlaceHolder = this.item.control.beginPlaceHolder;
                }
            }
            else {
                this.beginPlaceHolder = this.item.beginPlaceHolder;
            }
            const endplac = Object.prototype.toString.call(this.item.beginPlaceHolder);
            if (endplac == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.endPlaceHolder = this.item.control.endPlaceHolder;
                }
            }
            else {
                this.endPlaceHolder = this.item.endPlaceHolder;
            }

            if (!this.bigNumber) {
                this.min = -2147483648;
                this.max = 2147483647;
            }
        }


        (this.item.value as NumberRangeValue).clear$.subscribe(() => {
            this.beginValue = '';
            this.endValue = '';
        });

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
          const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
          if(isChange){
            this.constructMultiFieldNumberRange(this.item.value as NumberRangeValue);
          }
      }
      }
    ngAfterViewInit() {
        // if(!this.extend){
        //     const El = this.element.nativeElement;
        //     const itemWidth = El.clientWidth;
        //     El.querySelector('.list-filter-number-item').style.width = itemWidth + 'px';
        //     El.querySelector('.number-item-btns').style.width = itemWidth + 100 + 'px';
        // }
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }

    // constructNumberRange(value: NumberRangeValue): string{
    //     return "a~b".replace(/a/,value.startValue?value.startValue.toString().trim():"").replace(/b/,value.endValue?value.endValue.toString().trim():"");
    // }
    constructMultiFieldNumberRange(value: NumberRangeValue) {
        // this.beginValue = value && value.startValue ? value.startValue.toString().trim() : '';
        // this.endValue = value && value.endValue ? value.endValue.toString().trim() : '';
        this.beginValue = value.startValue == null ? null : value.startValue;
        this.endValue = value.endValue == null ? null : value.endValue;
    }

    numberChange(event) {
        if (event) {
            // const dataArray = event.split("~");
            // console.log(dataArray);
            // this._item.value = (new NumberRangeValueConvertor).initFromObject({startValue: dataArray[0], endValue: dataArray[1]});
            const dataArray = event.split("~");
            this.item.value.startValue = dataArray[0] ? dataArray[0] : null;
            this.item.value.endValue = dataArray[1] ? dataArray[1] : null;
        }
        else {
            this._item.value.startValue = null;
            this._item.value.endValue = null;
        }
        // const dataArray = event.split("~");
        // this._item.value = (new NumberRangeValueConvertor).initFromObject({startValue: dataArray[0], endValue: dataArray[1]});
        if (this.disabled) { return; }
        this.searchHandle.emit();
    }

    beginValueChange($event) {
        this.beginValue = $event;

    }

    endValueChange($event) {
        this.endValue = $event;
    }


    // onSearch(){
    //     if(this.disabled){return;}
    //     this.searchHandle.emit();
    // }
}